import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalExam = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "medicalExam",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12972",
			"data-name": "Path 12972",
			d: "M0,0H16V16H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12973",
			"data-name": "Path 12973",
			d: "M19.845,11.488a1.667,1.667,0,1,1-2.357,0,1.667,1.667,0,0,1,2.357,0",
			transform: "translate(-5.667 -3.667)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12974",
			"data-name": "Path 12974",
			d: "M4.667,3H3.333A1.333,1.333,0,0,0,2,4.333V7a4,4,0,0,0,8,0V4.333A1.333,1.333,0,0,0,8.667,3H7.333",
			transform: "translate(-0.667 -1)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12975",
			"data-name": "Path 12975",
			d: "M15.667,15.667v.167a3.833,3.833,0,1,1-7.667,0V15",
			transform: "translate(-2.667 -5)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12976",
			"data-name": "Path 12976",
			d: "M6,2V3.333",
			transform: "translate(-2 -0.667)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12977",
			"data-name": "Path 12977",
			d: "M10,2V3.333",
			transform: "translate(-3.333 -0.667)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})
	]
});
export default SvgMedicalExam;
